import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRobotoCondensed, theme, transientOptions } from "shared/lib/styles";

import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";

import IconAvatar from "./icon-avatar.svg";

export const Label = styled.div`
  display: none;

  color: #000000;
  white-space: nowrap;

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const StyledIconAvatar = styled(IconAvatar)`
  inline-size: 24px;
  block-size: 24px;

  transform: translateY(1px);

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

type DashboardContainerProps = ResponsiveStyledProps & {
  $isLight?: boolean;
};

export const DashboardContainer = styled("div", {
  ...transientOptions,
})<DashboardContainerProps>`
  color: #2c4692;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: 14px;
  white-space: nowrap;

  cursor: pointer;

  ${props =>
    props.$isLight &&
    css`
      padding-inline: 4px;

      color: #000000;
      font-weight: 400;
    `}

  ${responsiveStyles}
`;
